import api from '../../../../api/client'

export const DATE_PERIOD_OPTIONS = [
  { value: 'period', label: 'Period' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'current_week', label: 'Current Week' },
  { value: 'current_month', label: 'Current Month' },
  { value: 'current_year', label: 'Current Year' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_year', label: 'Last Year' },
  { value: 'next_week', label: 'Next Week' },
  { value: 'next_month', label: 'Next Month' },
  { value: 'next_year', label: 'Next Year' },
]

export let COMPANY_OPTIONS = ['All']
export let BRANCH_OPTIONS = ['All']
export let ACADEMIC_YEAR_OPTIONS = ['All', '2027-28', '2026-27', '2025-26', '2024-25']

/**
 * Fetch paginated list of student birthdays.
 * Communicates directly with backend FastAPI /admission/birthdays endpoint.
 */
export async function listBirthdays(params = {}) {
  const query = {
    company: params.company || 'All',
    branch: params.branch || 'All',
    academicYear: params.academicYear || 'All',
    course: params.course || 'All',
    batch: params.batch || 'All',
    period: params.period || params.datePeriod || '',
    fromDate: params.fromDate || '',
    toDate: params.toDate || '',
    searchField: params.searchField || 'Name',
    searchText: params.searchText || '',
    tab: params.tab || 'active',
    orderBy: params.orderBy || 5,
    page: params.page || 1,
    pageSize: params.pageSize || 25,
  }

  const response = await api.get('/admission/birthdays', { params: query })
  return response.data || { data: [], total: 0, page: 1, pageSize: 25, totalPages: 1 }
}

/**
 * Fetch KPI summary for birthdays: today, thisWeek, thisMonth, and total.
 */
export async function getBirthdaysSummary() {
  const response = await api.get('/admission/birthdays/summary')
  return response.data || { today: 0, thisWeek: 0, thisMonth: 0, total: 0 }
}

/**
 * Fetch filter dropdown options from the backend.
 */
export async function getBirthdayOptions() {
  const response = await api.get('/admission/birthdays/options')
  const data = response.data || {}

  if (Array.isArray(data.companies) && data.companies.length > 0) {
    COMPANY_OPTIONS = ['All', ...data.companies.filter((c) => c !== 'All')]
  }
  if (Array.isArray(data.branches) && data.branches.length > 0) {
    BRANCH_OPTIONS = ['All', ...data.branches.filter((b) => b !== 'All')]
  }
  if (Array.isArray(data.academicYears) && data.academicYears.length > 0) {
    ACADEMIC_YEAR_OPTIONS = ['All', ...data.academicYears.filter((y) => y !== 'All')]
  }

  return {
    companyOptions: COMPANY_OPTIONS,
    branchOptions: BRANCH_OPTIONS,
    academicYearOptions: ACADEMIC_YEAR_OPTIONS,
    datePeriodOptions: DATE_PERIOD_OPTIONS,
    courses: data.courses || [],
    batches: data.batches || [],
  }
}

/** Backward compatibility alias for option loading */
export const loadBirthdayOptions = getBirthdayOptions

/**
 * Fetch detailed birthday and enrollment profile for a single student.
 */
export async function getBirthdayDetail(studentId) {
  const response = await api.get(`/admission/birthdays/${studentId}`)
  return response.data
}

/**
 * Dispatch personalized birthday greeting wish (SMS / Email / Both).
 */
export async function sendBirthdayWish(studentId, payload) {
  const body = typeof payload === 'string'
    ? { message: payload, channel: 'both' }
    : { message: payload.message || '', channel: payload.channel || 'both' }

  const response = await api.post(`/admission/birthdays/${studentId}/send-wish`, body)
  return response.data
}
